module.exports = __webpack_public_path__ + "img/user.041643fc.png";